import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";

function FortalezasTareas(props) {
  const [list, setList] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/QEquipoUsuario?SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  const [postTarea, setPostTarea] = useState([]);

  const [postUsuario, setPostUsuario] = useState([]);
  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaTarea",
      data: {
        evaluadorId: postUsuario,
        tarea: postTarea,
        solicitudId: props.idSolicitud,
        grupo: "6",
        estado: "En proceso",
        comentarios: "",
        aplica: 1,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Tarea Asignada con exito !");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear" + error);
      });
  };
  const [list1, setList1] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerActividades/" +
        props.tipoSolicitudId,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);

  let filtro = list1.filter(
    (e) =>
      e.titulo ==
        "6.FORTALEZAS, AVANCES Y DESARROLLOS DE LOS ESTANDARESASISTENCIALES " ||
      e.titulo ==
        "6. ESTADO, RESULTADOS Y AVANCES DE LOS ESTANDARES ASISTENCIALES",
  );

  return (
    <div className="test">
      <div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  {props.tipoSolicitudId != 5 ? (
                    <h6 class="m-0 font-weight-bold text-primary">
                      6. FORTALEZAS, AVANCES Y DESARROLLOS DE LOS ESTÁNDARES
                      ASISTENCIALES
                    </h6>
                  ) : (
                    <h6 class="m-0 font-weight-bold text-primary">
                      6. ESTADO, RESULTADOS Y AVANCES DE LOS ESTANDARES
                      ASISTENCIALES
                    </h6>
                  )}
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <td>TITULO </td>
                          <td>EVALUADOR</td>
                          <td>ASIGNAR</td>
                        </tr>
                      </thead>
                      <tbody>
                        <td>
                          <select
                            className="btn btn-secondary btn-user btn-block text-justify"
                            onChange={(e) => setPostTarea(e.target.value)}
                          >
                            <option value="">Seleccione</option>
                            {filtro.map((item) => (
                              <option value={item.id} title={item.actividad}>
                                {item.actividad.length > 60
                                  ? item.actividad.substring(0, 60) + "..."
                                  : item.actividad}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <select
                            className="btn btn-secondary btn-user btn-block"
                            onChange={(e) => setPostUsuario(e.target.value)}
                          >
                            <option value="">Seleccione</option>
                            {list.map((item) => (
                              <option value={item.evaluadorId}>
                                {item.nombre}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <a>
                            <button
                              className="btn btn-primary btn-user btn-block"
                              onClick={postData}
                            >
                              Guardar
                            </button>
                          </a>
                        </td>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default FortalezasTareas;
